export const APP_NAME = 'audit-log';

export const AUDIT_LOG_ROUTE_ROOT = '/audit-log';
